module.exports = __webpack_public_path__ + "img/H3.42f5a4b3.png";